export default {
    user: function() {
        this.fillWorkProfiles()
    }
}
